/**
 * Formatter utilities for Canadian tax portal inputs and display:
 * - Phone number: 647-855-6177 (XXX-XXX-XXXX)
 * - SIN Number: 569 435 228 (XXX XXX XXX)
 * - Business Number: 71035 1909 RC 0001 (XXXXX XXXX XX XXXX)
 */

/**
 * Formats phone number into standard 10-digit North American format: XXX-XXX-XXXX
 * e.g., "6478556177" or "+16478556177" -> "647-855-6177"
 */
export const formatPhoneNumber = (value = '') => {
  if (!value) return '';
  let digits = String(value).replace(/\D/g, '');
  if (digits.length === 11 && digits.startsWith('1')) {
    digits = digits.slice(1);
  } else if (digits.length > 10) {
    digits = digits.slice(0, 10);
  }
  if (digits.length <= 3) return digits;
  if (digits.length <= 6) return `${digits.slice(0, 3)}-${digits.slice(3)}`;
  return `${digits.slice(0, 3)}-${digits.slice(3, 6)}-${digits.slice(6, 10)}`;
};

/**
 * Formats Social Insurance Number (SIN) into standard CRA 9-digit format: XXX XXX XXX
 * e.g., "569435228" -> "569 435 228"
 */
export const formatSinNumber = (value = '') => {
  if (!value) return '';
  const digits = String(value).replace(/\D/g, '').slice(0, 9);
  if (digits.length <= 3) return digits;
  if (digits.length <= 6) return `${digits.slice(0, 3)} ${digits.slice(3)}`;
  return `${digits.slice(0, 3)} ${digits.slice(3, 6)} ${digits.slice(6, 9)}`;
};

/**
 * Formats Canadian Business Number (BN15) into standard CRA format: XXXXX XXXX XX XXXX
 * e.g., "710351909RC0001" -> "71035 1909 RC 0001"
 * Also supports 9-digit BN: "710351909" -> "71035 1909"
 */
export const formatBusinessNumber = (value = '') => {
  if (!value) return '';
  const clean = String(value).toUpperCase().replace(/[^A-Z0-9]/g, '').slice(0, 15);
  const parts = [];
  if (clean.length > 0) parts.push(clean.slice(0, 5));
  if (clean.length > 5) parts.push(clean.slice(5, 9));
  if (clean.length > 9) parts.push(clean.slice(9, 11));
  if (clean.length > 11) parts.push(clean.slice(11, 15));
  return parts.join(' ');
};

